import { useEffect } from "react";
import {
  Box,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography as T,
} from "@mui/material";

import { useCurrency } from "hooks";
import { palette } from "theme/palette";

export const CurrencySelector = () => {
  const { currency, setCurrency, currencyOptions, ensureRatesLoaded } =
    useCurrency();

  useEffect(() => {
    ensureRatesLoaded();
  }, [ensureRatesLoaded]);

  const options = currencyOptions.length
    ? currencyOptions
    : [{ value: currency, label: currency.toUpperCase() }];

  const handleChange = (event: SelectChangeEvent<string>) => {
    setCurrency(event.target.value);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 0.5,
        marginBottom: "16px",
      }}
    >
      <T variant="cardLabelText" color="inherit">
        Currency
      </T>
      <Select
        size="small"
        fullWidth
        value={currency}
        onChange={handleChange}
        disabled={currencyOptions.length === 0}
        sx={{
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          borderRadius: "8px",
          color: "inherit",
          fontWeight: 600,
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "& .MuiSelect-icon": {
            color: "inherit",
          },
        }}
        MenuProps={{
          disablePortal: true,
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
          PaperProps: {
            sx: {
              backgroundColor: palette.white,
              color: "#1f1f1f",
            },
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};
